export default {
      id: "incoming-call-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#incoming-call-usage",
      toString: function () {
        return this.url;
      }
    }